import Loop from "../loop";
import CareerTeaser from "./career-teaser";

export default Loop(CareerTeaser);
